import { Facebook, Globe, Instagram, Mail, Phone, Twitter } from 'lucide-react'
import type { ReactNode } from 'react'

interface ContactLinksProps {
  phone?: string
  email?: string
  website?: string
  facebook?: string
  instagram?: string
  twitter?: string
}

function absolute(value: string, base: string): string {
  return value.startsWith('http') ? value : `${base}${value}`
}

function ContactLink({
  href,
  icon,
  children,
}: {
  href: string
  icon: ReactNode
  children: string
}) {
  const external = href.startsWith('http')
  return (
    <li className="min-w-0">
      <a
        href={href}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        className="flex min-w-0 items-center gap-2 hover:underline"
      >
        <span className="shrink-0 text-muted-foreground [&_svg]:size-4">{icon}</span>
        <span className="truncate">{children}</span>
      </a>
    </li>
  )
}

export function hasContactLinks(props: ContactLinksProps): boolean {
  return Object.values(props).some(Boolean)
}

export function ContactLinks({
  phone,
  email,
  website,
  facebook,
  instagram,
  twitter,
}: ContactLinksProps) {
  return (
    <ul className="grid gap-1.5 sm:grid-cols-2">
      {phone && (
        <ContactLink href={`tel:${phone}`} icon={<Phone />}>
          {phone}
        </ContactLink>
      )}
      {email && (
        <ContactLink href={`mailto:${email}`} icon={<Mail />}>
          {email}
        </ContactLink>
      )}
      {website && (
        <ContactLink href={absolute(website, 'https://')} icon={<Globe />}>
          {website}
        </ContactLink>
      )}
      {instagram && (
        <ContactLink href={absolute(instagram, 'https://instagram.com/')} icon={<Instagram />}>
          {instagram}
        </ContactLink>
      )}
      {facebook && (
        <ContactLink href={absolute(facebook, 'https://facebook.com/')} icon={<Facebook />}>
          {facebook}
        </ContactLink>
      )}
      {twitter && (
        <ContactLink href={absolute(twitter, 'https://twitter.com/')} icon={<Twitter />}>
          {twitter}
        </ContactLink>
      )}
    </ul>
  )
}
